import { render, staticRenderFns } from "./SocialAccounts.vue?vue&type=template&id=6d5df3a0&scoped=true&"
import script from "./SocialAccounts.vue?vue&type=script&lang=js&"
export * from "./SocialAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SocialAccounts.vue?vue&type=style&index=0&id=6d5df3a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5df3a0",
  null
  
)

export default component.exports